export default "/images/rotate-cw.svg?f81b4cb9876afdd12d2cc7a555bfcdce";